import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import { TreatmentFeedbackSummaryConverter } from '../../../api/models/converter/treatment-feedback.summary.converter';
import { TreatmentFeedbackModel } from '../../../api/models/treatment-feedback.model';
import { TreatmentFeedbackSummaryModel } from '../../../api/models/treatment-feedback.summary.model';
import { TreatmentFeedbackDataService } from './treatment-feedback.data.service';

@Injectable()
export class TreatmentFeedbackSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    TreatmentFeedbackSummaryModel,
    TreatmentFeedbackSummaryConverter,
    TreatmentFeedbackModel> {
    constructor(dataService: TreatmentFeedbackDataService, converter: TreatmentFeedbackSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): TreatmentFeedbackModel {
        return new TreatmentFeedbackModel();
    }
}
